import React from 'react'

export default function CheckCircleOutlineIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.06634 11.0666L11.7663 6.36658L10.833 5.43325L7.06634 9.19992L5.16634 7.29992L4.23301 8.23325L7.06634 11.0666ZM7.99967 14.6666C7.07745 14.6666 6.21079 14.4916 5.39967 14.1416C4.58856 13.7916 3.88301 13.3166 3.28301 12.7166C2.68301 12.1166 2.20801 11.411 1.85801 10.5999C1.50801 9.78881 1.33301 8.92214 1.33301 7.99992C1.33301 7.0777 1.50801 6.21103 1.85801 5.39992C2.20801 4.58881 2.68301 3.88325 3.28301 3.28325C3.88301 2.68325 4.58856 2.20825 5.39967 1.85825C6.21079 1.50825 7.07745 1.33325 7.99967 1.33325C8.9219 1.33325 9.78856 1.50825 10.5997 1.85825C11.4108 2.20825 12.1163 2.68325 12.7163 3.28325C13.3163 3.88325 13.7913 4.58881 14.1413 5.39992C14.4913 6.21103 14.6663 7.0777 14.6663 7.99992C14.6663 8.92214 14.4913 9.78881 14.1413 10.5999C13.7913 11.411 13.3163 12.1166 12.7163 12.7166C12.1163 13.3166 11.4108 13.7916 10.5997 14.1416C9.78856 14.4916 8.9219 14.6666 7.99967 14.6666ZM7.99967 13.3333C9.48856 13.3333 10.7497 12.8166 11.783 11.7833C12.8163 10.7499 13.333 9.48881 13.333 7.99992C13.333 6.51103 12.8163 5.24992 11.783 4.21659C10.7497 3.18325 9.48856 2.66659 7.99967 2.66659C6.51079 2.66659 5.24967 3.18325 4.21634 4.21659C3.18301 5.24992 2.66634 6.51103 2.66634 7.99992C2.66634 9.48881 3.18301 10.7499 4.21634 11.7833C5.24967 12.8166 6.51079 13.3333 7.99967 13.3333Z'
        fill='currentColor'
      />
    </svg>
  )
}
